/**
 * @generated SignedSource<<9a4b9f2184d2349336915a24771feb99>>
 * @relayHash 1b5c054b075946a6f23916dfd3d37eb7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 35af847465ee0bc4dd77ad7232fdd3fe8c728f0efee56881aa566ab4ba8d8338

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

import withInlineCreateMigration_provider from '@atlassian/jira-relay-provider/src/ibs-44-board-inline-create-migration.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "35af847465ee0bc4dd77ad7232fdd3fe8c728f0efee56881aa566ab4ba8d8338",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": withInlineCreateMigration_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider
    }
  }
};

export default node;
